import type { TagJournalDto } from "~/types/api";
import { BaseAPI } from "./base";
import type { ApiResponse } from "~/types/ui";

export class NodeJournalApi extends BaseAPI {
  async uploadImage(
    deveui: string,
    image: FormData,
  ): Promise<ApiResponse<void>> {
    return this.post<void>(`tag/${deveui}/image`, image);
  }

  async deleteImage(deveui: string): Promise<ApiResponse<void>> {
    return this.delete<void>(`tag/${deveui}/image`);
  }

  async getJournals(deveui: string): Promise<ApiResponse<TagJournalDto[]>> {
    return this.get<TagJournalDto[]>(`tagJournal/tag/${deveui}`);
  }

  async createJournalEntry(
    deveui: string,
    payload: TagJournalDto,
  ): Promise<ApiResponse<TagJournalDto>> {
    return this.post<TagJournalDto>(`tagJournal/${deveui}`, payload);
  }

  async uploadJournalFiles(files: File[]): Promise<ApiResponse<string[]>> {
    const formData = new FormData();
    for (const file of files) {
      formData.append("files", file);
    }
    return this.post<string[]>(
      `tagJournalFile/upload/${this.company()}/bulk`,
      formData,
    );
  }

  async updateJournalEntry(
    tagJournalId: number,
    payload: TagJournalDto,
  ): Promise<ApiResponse<TagJournalDto>> {
    return this.put<TagJournalDto>(
      `tagJournal/update/${tagJournalId}`,
      payload,
    );
  }

  async deleteJournalEntry(tagJournalId: number): Promise<ApiResponse<void>> {
    return this.delete<void>(`tagJournal/delete/${tagJournalId}`);
  }
}
